import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Avatar,
    Box,
    Divider,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Typography,
    styled, // wrap
    alpha,
} from '@mui/material';
import { ReactComponent as Account } from '../../shared/icons/Account.svg';
import { ReactComponent as Notification } from '../../shared/icons/Notification.svg';
import { ReactComponent as Logout } from '../../shared/icons/Logout.svg';

const AvatarWrap = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '42px',
    width: '42px',
    borderRadius: '4.5px',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
    height: '32px',
    width: '32px',
    backgroundColor: theme.palette.primary.light,
    fontSize: '14px',
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    '& .MuiListItemIcon-root': {
        minWidth: 0,
        marginRight: theme.spacing(1.25),
        color: alpha(theme.palette.secondary.main, 0.54),
    },
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
}));

const UserMenuButton = ({ user }) => {
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleLinkClick = (path) => {
        history.push(path);
    };

    const canAccessAccount = ['admin', 'producer', 'processor'].includes(user.role);
    const canAccessNotifications = ['admin', 'producer', 'processor', 'transport', 'producer_business'].includes(user.role);

    return (
        <>
            <AvatarWrap onClick={handleOpen}>
                <StyledAvatar>{user.name?.[0] || '?'}</StyledAvatar>
            </AvatarWrap>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{
                    paper: {
                        sx: { width: 220, py: 0, px: 1 },
                    },
                }}
            >
                <Box display="flex" alignItems="center" p={1}>
                    <StyledAvatar sx={{ mr: 1 }}>{user.name?.[0] || '?'}</StyledAvatar>
                    <Box sx={{ minWidth: 0, maxWidth: '100%' }}>
                        <Typography
                            fontWeight={600}
                            fontSize="14px"
                            noWrap
                            sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }} //
                        >
                            {user.name}
                        </Typography>
                        <Typography
                            fontSize="13px"
                            color="text.secondary"
                            noWrap
                            sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }} //
                        >
                            {user.email}
                        </Typography>
                    </Box>
                </Box>
                {canAccessAccount && (
                    <StyledMenuItem onClick={() => handleLinkClick('/user-settings')}>
                        <ListItemIcon>
                            <Account height={20} width={20} />
                        </ListItemIcon>
                        <ListItemText primary="Account Profile" />
                    </StyledMenuItem>
                )}
                {canAccessNotifications && (
                    <StyledMenuItem onClick={() => handleLinkClick('/notifications-settings')}>
                        <ListItemIcon>
                            <Notification height={20} width={20} />
                        </ListItemIcon>
                        <ListItemText primary="Notification Settings" />
                    </StyledMenuItem>
                )}

                <Divider sx={{ my: 1 }} />

                <StyledMenuItem onClick={() => handleLinkClick('/logout')}>
                    <ListItemIcon>
                        <Logout height={20} width={20} />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                </StyledMenuItem>
            </Menu>
        </>
    );
};

export default UserMenuButton;
